import { toggleMenu as toggleMenuActionType } from "../types"

export default function toggleMenu() {
  return {
    type: toggleMenuActionType,
  }
}
